enum Services {
    Contents = 1,
    FmWorld = 2,
    Webinar = 3
}

export default Services
